<button 
  [ngClass]="loading && type === 'primary-large' ? 'loading-primary-large' :
  loading && type === 'primary-wide' ? 'loading-primary-wide' :
  loading && type === 'secondary-large' ? 'loading-secondary-large' :
  loading && type === 'secondary-wide' ? 'loading-secondary-wide' : type"
  [disabled]="disabled || loading"
  (click)="handleClick()">
  <ng-container *ngIf="!loading">{{ text }}</ng-container>
  <ng-container *ngIf="loading">
    <span class="dot" [ngClass]="type.indexOf('primary') !== -1 ? 'background-primary' : 'background-secondary'"></span>
    <span class="dot" [ngClass]="type.indexOf('primary') !== -1 ? 'background-primary' : 'background-secondary'"></span>
    <span class="dot" [ngClass]="type.indexOf('primary') !== -1 ? 'background-primary' : 'background-secondary'"></span>
  </ng-container>
</button>